export interface ModerationFlag {
  id: string;
  name: string;
  description: string;
  enabled: boolean;
  icon: "sexual" | "hate" | "harassment" | "selfHarm" | "violence";
  emails: string;
}

export const initialModerationSettings: ModerationFlag[] = [
  {
    id: "sexual",
    name: "Sexual Content",
    description: "Detection of explicit sexual content, references, and content involving minors",
    enabled: true,
    icon: "sexual",
    emails: "",
  },
  {
    id: "hate",
    name: "Hate & Discrimination",
    description: "Detection of hateful, discriminatory, or threatening content based on protected characteristics",
    enabled: true,
    icon: "hate",
    emails: "",
  },
  {
    id: "harassment",
    name: "Harassment",
    description: "Detection of harassing, bullying, or threatening content directed at individuals",
    enabled: true,
    icon: "harassment",
    emails: "",
  },
  {
    id: "selfHarm",
    name: "Self-Harm",
    description:
      "Detection of self-harm related content, expressions of intent, or instructions - critical for student safety",
    enabled: true,
    icon: "selfHarm",
    emails: "",
  },
  {
    id: "violence",
    name: "Violence",
    description: "Detection of violent content, threats, or graphic depictions of violence",
    enabled: true,
    icon: "violence",
    emails: "",
  },
];
